// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //baseApiUrl: 'https://localhost:44332',
  // baseApiUrl: 'http://localhost:22076',
  // baseApiUrl: 'http://property-mgmt-alb-687331919.us-east-1.elb.amazonaws.com',
  // For New-Staging
  // baseApiUrl: 'https://ms.stagingsdei.com:9230',
  // For Staging

  baseApiUrl: 'https://property-api.jape.com.au',
  
  // baseApiUrl: 'https://ms.stagingsdei.com:9018',
  //s3 bucket branch
  // baseApiUrl: 'https://apipreprdproperty.jape.com.au',

  // For AI chat bot 
  
  // baseApiUrl: 'https://ms.stagingsdei.com:9321',
  ////  For Production
  //Frontend: 'https://preprdproperty.jape.com.au/auth',
  
  // baseApiUrl: 'https://property.jape.com.au:9018',
  // baseApiUrl: 'https://3.225.61.235:9018',
  encryptionKey:
    'XBLUBMWzHSrR/OSYDD+JfuVY0wYk9wPl8LapodPHIOh6uGhih9TS1G9/eVXD+uOGT+Kh60uuvBbCWymtZH/a6Bw==',
  s3BaseUrl: 'https://propertymanagement-prod-data-bucket.s3.us-east-1.amazonaws.com'
  //placesApiKey: 'AIzaSyAl1wjOH8NV2KHLerNuFaEgrFsVukAODJc',
  //drugsEndpoints: 'https://dailymed.nlm.nih.gov/dailymed/services/v2/',
  //payPalClientId: 'AZccXTx6066hTILLXWk_ZUScp_5WD7GvdNIxy9VtPOLFUGDZC0xHTob-lt9oZFlb7bkIvw25gVFW2BQ7'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
